export default {
  get(translations, locale, property) {
    let t = translations.filter(x => x.locale == locale);
    if (t.length > 0) {
      return t[0][property];
    }
    return "Translation not provided";
  },

  getListLanguages(languages, languages_actives){
    return languages.filter(x => languages_actives.includes(x.id));
  }
};
